import { ObjectMapper } from 'json-object-mapper';
import { IModel } from './IModel';

export class DistrictModel implements IModel<DistrictModel> {
  public code = '';
  public name = '';
  public state = '';

  static create(input: any): DistrictModel {
    return ObjectMapper.deserialize<DistrictModel>(DistrictModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
